import { createContext } from "react";

export const ControllerContext = createContext({});